import React from 'react';
import { characters } from '../character_db';
import { useLang } from '../i18n';

function CharacterSelection({ onCharacterSelect }) {
  const { t, toggleLang } = useLang();

  return (
    <div className="character-selection-screen">
      <div className="header-bar">
        <h2>{t.chooseYourTeacher}</h2>
        <button className="lang-toggle-button" onClick={toggleLang}>
          {t.langToggle}
        </button>
      </div>
      <div className="character-grid">
        {characters.map((character) => (
          <div
            key={character.id}
            className="character-card"
            onClick={() => onCharacterSelect(character)}
          >
            <video
              className="character-video"
              src={character.profileVideo}
              autoPlay
              loop
              muted
              playsInline
            />
            <p className="character-name">{character.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CharacterSelection;
